import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { defineCustomElements } from '@eon-ui/eon-ui-components/loader';
defineCustomElements(); // this registers the E.ON UI components in the browser

bootstrapApplication(AppComponent, appConfig).catch((err) => console.error(err));
